<template>
    <ul class="list-disc list-inside pl-5 space-y-2">
        <li v-for="(child, index) in $slots.default()" :key="index" class="space-x-4 text-xl">
            <component :is="child"></component>
        </li>
    </ul>
</template>

<script setup>
const slots = defineSlots();
</script>
